import React from 'react';
import { Image, Text } from 'react-native-web';
import { getRegularFont, xlateText } from '../../../../utils/Utils';
import { img_emoji, img_globe } from '../../../../utils/ImagesManagementUtils';
import { emoji_param, globe_param } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================
const SentenceWIthEmuji = ({
  globJSON,
  simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const txt = xlateText(globJSON.configurations.onboarding.instructions.o_i_touch_and_hold, globJSON);
  const idxGlobe = txt.indexOf(globe_param);
  const idxEmoji = txt.indexOf(emoji_param);
  let txt1 = txt;
  let txt2 = '';
  let txt3 = '';
  let firstImage = null;
  let secondImage = null;
  if (idxGlobe !== -1 && idxEmoji === -1) {
    // only globe
    txt1 = txt.substring(0, idxGlobe);
    txt2 = txt.substring(idxGlobe + 7);
    firstImage = img_globe;
  }
  if (idxGlobe === -1 && idxEmoji !== -1) {
    // only emoji
    txt1 = txt.substring(0, idxEmoji);
    txt2 = txt.substring(idxEmoji + 7);
    firstImage = img_emoji;
  }
  if (idxGlobe !== -1 && idxEmoji !== -1) {
    // both exist
    if (idxGlobe > idxEmoji) {
      // emoji is first
      txt1 = txt.substring(0, idxEmoji);
      txt2 = txt.substring(idxEmoji + 7, idxGlobe);
      txt3 = txt.substring(idxGlobe + 7);
      firstImage = img_emoji;
      secondImage = img_globe;
    } else {
      txt1 = txt.substring(0, idxGlobe);
      txt2 = txt.substring(idxGlobe + 7, idxEmoji);
      txt3 = txt.substring(idxEmoji + 7);
      firstImage = img_globe;
      secondImage = img_emoji;
    }
  }

  const myStyles = {
    Container: {
      marginLeft: 19,
      marginTop: 125,
      width: 191,
      height: 22,
      position: 'absolute',
    },
    txtStyle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: colors.primary_font_color,
    },
    imageStyle: {
      width: 13, height: 13,
    },
  };

  return (
    <Text style={myStyles.Container}>
      <Text style={myStyles.txtStyle}>{txt1}</Text>
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.imageStyle}
        source={firstImage}
      />
      <Text style={myStyles.txtStyle}>{txt2}</Text>
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.imageStyle}
        source={secondImage}
      />
      <Text style={myStyles.txtStyle}>{txt3}</Text>
    </Text>

  );
};

export default SentenceWIthEmuji;
